/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Group_Type_TranslationInputs */



/**
* | output |
* | --- |
* | "Translation" |
*
* @param {Merge_Event_Group_Group_Type_TranslationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_group_type_translation = /** @type {((inputs?: Merge_Event_Group_Group_Type_TranslationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Group_Type_TranslationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Traduction")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Traduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перевод")
	if (locale === "es") return /** @type {LocalizedString} */ ("Traducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("翻译")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tradução")
	return /** @type {LocalizedString} */ ("Translation")
});